import { Alert, AlertTitle, Box, Button, Link, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import { DEFAULT_ERROR_MESSAGE } from '../lib/fulcrumApi';
import { JSX } from 'react';

interface InlineErrorProps {
  /**
   * Error to display
   */
  error: unknown;
  /**
   * Label for the action button
   */
  actionLabel?: string;
  /**
   * URL for the action button
   */
  actionUrl?: string;
}

/**
 * Base component for displaying an error inline on a page
 */
const InlineError = ({ error, actionLabel, actionUrl }: InlineErrorProps): JSX.Element => {
  const errorData = (error as AxiosError)?.response?.data as string | Array<string> | undefined;
  const errorMessage = errorData || (error as Error)?.message || DEFAULT_ERROR_MESSAGE;

  return (
    <Alert severity="warning" variant="filled">
      <AlertTitle color="primary.main">
        <Typography fontWeight={700}>Something doesn`t seem right</Typography>
      </AlertTitle>
      {Array.isArray(errorMessage) ? (
        <ul className="list-disc ml-4 space-y-2">
          {errorMessage.map((error) => (
            <li key={error}>
              <Typography lineHeight={1.3}>{error}</Typography>
            </li>
          ))}
        </ul>
      ) : (
        <Typography>{errorMessage}</Typography>
      )}
      {actionLabel && (
        <Box className="mt-4">
          <Button component={Link} href={actionUrl} variant="contained">
            {actionLabel}
          </Button>
        </Box>
      )}
    </Alert>
  );
};

export default InlineError;
